import './DetailsControlBar.css';
export var controlBar = '_1y5ro0l0-3-8-0';
export var customActions = '_1y5ro0l1-3-8-0';
export var defaultActions = '_1y5ro0l2-3-8-0';